// The public sign-up page (backend docs/customer-module/kyc/17 §1, §2): one
// route, opened only from each SACCO's own website link. It is linked from no
// menu and not from the login page. No staff login (auth: false), its own
// layout (PublicLayout: no menu, shown whether or not a staff user is signed
// in), and no permission.
export default [
    {
        name: "selfRegistration",
        path: "/join/:companyCode",
        component: () => import("./SelfRegistration.vue"),
        meta: {
            auth: false,
            title: "Join",
            layout: "PublicLayout",
            permission: [],
        },
    },
];
